import { i18n } from '../../lib/lang';
import { LANGUAGE_TAG_ENUM } from '../../lib/lang/value';

export const MODULE_NAME = 'POPUP_ADMIN_LIST_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const API = {
  TYPE: 'GET',
  URL: (params: string) => `/popup/admin-list/${params}`,
};

export enum POPUP_STATUS {
  ACTIVE = 1,
  DISABLED = 2,
}

export const POPUP_STATUS_VIEW = {
  [POPUP_STATUS.ACTIVE]: 'POPUP.STATUS.ACTIVE',
  [POPUP_STATUS.DISABLED]: 'POPUP.STATUS.DISABLED',
};

export interface POPUP_ITEM_DATA_RAW_INTER {
  id: string;
  body: string;

  linkUrl?: string;
  imgUrl?: string;
  deadline: string;

  status: POPUP_STATUS;
  lang: LANGUAGE_TAG_ENUM;
}

export interface POPUP_ITEM_LIST_DATA_RAW_INTER {
  list: POPUP_ITEM_DATA_RAW_INTER[];
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface POPUP_ITEM_DATA_INTER
  extends Omit<POPUP_ITEM_DATA_RAW_INTER, 'status' | 'lang'> {
  deadlineView?: string;

  status: {
    label: string;
    value: number;
  }[];

  lang: {
    label: string;
    value: string;
  }[];
}

export const POPUP_STATUS_LIST = [
  {
    label: i18n.t(POPUP_STATUS_VIEW[POPUP_STATUS.ACTIVE]),
    value: POPUP_STATUS.ACTIVE,
  },
  {
    label: i18n.t(POPUP_STATUS_VIEW[POPUP_STATUS.DISABLED]),
    value: POPUP_STATUS.DISABLED,
  },
];
